import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Activity, 
  BookOpen, 
  TrendingUp, 
  MessageSquare, 
  ShoppingCart,
  DollarSign,
  LogOut,
  Menu,
  X,
  Info
} from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/activities', icon: Activity, label: 'Activities' },
    { path: '/admin/resources', icon: BookOpen, label: 'Resources' },
    { path: '/admin/self-improvement', icon: TrendingUp, label: 'Self-Improvement' },
    { path: '/admin/pricing', icon: DollarSign, label: 'Pricing' },
    { path: '/admin/digital-products', icon: ShoppingCart, label: 'Digital Products' },
    { path: '/admin/sales', icon: DollarSign, label: 'Sales Dashboard' },
    { path: '/admin/homepage', icon: LayoutDashboard, label: 'Homepage Editor' },
    { path: '/admin/about', icon: Info, label: 'About Page Editor' },
    { path: '/admin/contacts', icon: MessageSquare, label: 'Contacts' },
  ];

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className={`${
        sidebarOpen ? 'w-64' : 'w-20'
      } bg-gradient-to-b from-blue-900 to-teal-900 text-white transition-all duration-300 flex flex-col`}>
        {/* Header */}
        <div className="p-4 flex items-center justify-between border-b border-teal-700">
          {sidebarOpen && (
            <h1 className="text-xl font-bold">Admin Panel</h1>
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 hover:bg-teal-800 rounded-lg"
          >
            {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
                  isActive(item.path)
                    ? 'bg-teal-700 text-white'
                    : 'hover:bg-teal-800 text-teal-100'
                }`}
              >
                <Icon className="h-5 w-5" />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        {/* User section */}
        <div className="p-4 border-t border-teal-700">
          {sidebarOpen ? (
            <div>
              <p className="text-sm text-teal-200 mb-1">Logged in as</p>
              <p className="font-semibold mb-3">{user?.name}</p>
              <Button
                onClick={handleLogout}
                variant="outline"
                className="w-full border-teal-400 text-white hover:bg-teal-800"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </div>
          ) : (
            <button
              onClick={handleLogout}
              className="p-2 hover:bg-teal-800 rounded-lg w-full flex justify-center"
            >
              <LogOut className="h-5 w-5" />
            </button>
          )}
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;